<div [class.clickable]="clickable">
  <label class="next-appointment-text">Prochain RDV</label>
  <label [tooltip]="info"
         class="next-appointment-date-text"
         placement="bottom"
         container="body">
    {{ appointment && appointment.date ? ('Le ' + formattedDate) : 'Nouveau rendez-vous' }}
  </label>

  <ng-template #info>
    <div>Lieu : {{appointment?.location ?? 'Non précisé'}}</div>
    <div>Durée : {{appointment?.duration}} minutes</div>
    <div>Motif : {{appointment?.comment ?? 'Non précisé'}}</div>
  </ng-template>
</div>
